import React, { Component, Fragment } from 'react';
import { Row, Col, Input, Label, Button, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import PermissionWrapper from '../../auth/PermissionWrapper';
import CollapseCard from '../CollapseCard/CollapseCard';
import ConfirmButton from '../Modal/ConfirmButton';

class BOTRequestsForm extends Component {

    formatDate = (d) => {
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }

    checkPermission = (permission) => {
        this.props.info('EmployeesContainer.js/checkPermission (permission)', permission);
        const permissionGranted =
            permission === '' || permission == null ||
            this.props.userPermissions.findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1;
        return permissionGranted;
    }

    standardRow = (requestTicket) => {
        this.props.info('BOTRequestsForm.js/standardRow (requestTicket)', requestTicket);
        return (
            <tr className="adminRow pointer widgetRow text-left" onClick={() => this.props.onEdit(requestTicket.id)}>
                {(this.props.singleEmployee == null || !this.props.singleEmployee) && <td>{requestTicket.lastName}, {requestTicket.firstName}</td>}
                <td>{requestTicket.assignedLastName}, {requestTicket.assignedFirstName}</td>
                {(this.props.singleEmployee == null || !this.props.singleEmployee) && <td>{requestTicket.teamName}</td>}
                <td>{requestTicket.clientName}</td>
                <td>{requestTicket.requestId === 4 ? requestTicket.requestOther : this.props.requests.filter(item => item.key === requestTicket.requestId)[0].value}</td>
                <td>{requestTicket.priorityId > 0 ? this.props.priorities.filter(item => item.key === requestTicket.priorityId)[0].value : ''}</td>
                <td>{requestTicket.timeSavedEstimate} {requestTicket.timeSavedEstimate != null && requestTicket.timeSavedEstimate !== '' && 'h'}</td>
                <td>{requestTicket.timeEstimate} {requestTicket.timeEstimate != null && requestTicket.timeEstimate !== '' && 'h'}</td>
            </tr>
        )
    }

    editRow = (requestTicket) => {
        this.props.log('BOTRequestsForm.js/editRow (requestTicket)', requestTicket);
        let clients = this.props.clients;
        if (this.props.singleEmployee && !this.checkPermission('Show All Clients')) {
            const allEmployeeClients = (this.props.userEmployee.primaryCustomers != null ? this.props.userEmployee.primaryCustomers : [])
                .concat(this.props.userEmployee.secondaryCustomers != null ? this.props.userEmployee.secondaryCustomers : [])
                .concat(this.props.userEmployee.teamCustomers != null ? this.props.userEmployee.teamCustomers : [])
                .map(client => client.clientId);
            clients = clients.filter(client => allEmployeeClients.findIndex(employeeClient => employeeClient === client.id) > -1);
        }
        return (<tr><td colSpan={8}>
            <Row className="adminRow activeTab text-left align-top">
                <Col md={6}>
                    {(this.props.singleEmployee == null || !this.props.singleEmployee) && <Row>
                        <Col md={4}>Employee</Col>
                        <Col>
                            <Input
                                type="select"
                                name="employeeId"
                                value={this.props.isFieldNull(this.props.editRequestTicket.employeeId)}
                                onChange={e => this.props.onChange(e, 'edit')} >
                                <option value={0}>SELECT EMPLOYEE</option>
                                {this.props.employees.map(employee => (
                                    <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.lastName}, {employee.firstName} </option>
                                ))}
                            </Input>
                        </Col>
                    </Row>}
                    {(this.props.singleEmployee == null || !this.props.singleEmployee) && <Row>
                        <Col md={4}>Team</Col>
                        <Col>
                            <Input type="select"
                                name="teamId"
                                onChange={(e) => this.props.onChange(e, 'edit')}
                                value={this.props.isFieldNull(this.props.editRequestTicket.teamId)}
                            >
                                <option value="0">SELECT TEAM</option>
                                {this.props.teams.map(team => (
                                    <option key={team.id}
                                        value={this.props.isFieldNull(team.id)}>{team.id === -1 ? 'Team Not Set' : team.teamName}</option>
                                ))}
                            </Input>
                        </Col>
                    </Row>}
                    <Row>
                        <Col md={4}>Client</Col>
                        <Col>
                            <Input type="select"
                                name="clientId"
                                onChange={(e) => this.props.onChange(e, 'edit')}
                                value={this.props.isFieldNull(this.props.editRequestTicket.clientId)}
                            >
                                <option value="0">SELECT CLIENT</option>
                                {clients.map(client => (
                                    <option key={client.id}
                                        value={this.props.isFieldNull(client.id)}>{client.client}</option>
                                ))}
                            </Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Request Category</Col>
                        <Col>
                            <Input
                                type="select"
                                name="requestId"
                                value={this.props.isFieldNull(this.props.editRequestTicket.requestId)}
                                onChange={e => { this.props.onChange(e, 'edit'); this.props.onChange({ persist: function () { }, target: { name: 'requestOther', value: '' } }) }} >
                                <option value={0}>SELECT REQUEST CATEGORY</option>
                                {this.props.requests.map(request => (
                                    <option key={request.key} value={this.props.isFieldNull(request.key)}>{request.value}</option>
                                ))}
                            </Input>
                        </Col>
                    </Row>
                    {parseInt(this.props.newRequestTicket.requestId) === 4 && <Row>
                        <Col md={4}></Col>
                        <Col>
                            <Input
                                placeholder="Enter Custom Category"
                                type="text"
                                name="requestOther"
                                value={this.props.isFieldNull(this.props.editRequestTicket.requestOther)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </Col>
                    </Row>}
                    <Row>
                        <Col md={4}>Connectivity</Col>
                        <Col>
                            <Input
                                placeholder="Connectivity Category"
                                type="text"
                                name="connectivityOther"
                                value={this.props.isFieldNull(this.props.editRequestTicket.connectivityOther)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Requestor Priority</Col>
                        <Col>
                            <Input
                                type="select"
                                name="priorityId"
                                value={this.props.isFieldNull(this.props.editRequestTicket.priorityId)}
                                onChange={e => this.props.onChange(e, 'edit')} >
                                <option value={0}>SELECT PRIORITY</option>
                                {this.props.priorities.map(priority => (
                                    <option key={priority.key} value={this.props.isFieldNull(priority.key)}>{priority.value}</option>
                                ))}
                            </Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Estimated Time Saved<br /><span className="pl-2">(in hours) for each event</span></Col>
                        <Col>
                            <Input
                                type="number"
                                name="timeSavedEstimate"
                                value={this.props.isFieldNull(this.props.editRequestTicket.timeSavedEstimate)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Client Directed</Col>
                        <Col>
                            <Label className='mr-4'>Yes
                                <Input
                                    className='ml-2'
                                    type="radio"
                                    name="clientDirected-edit"
                                    checked={this.props.isFieldNull(this.props.editRequestTicket.clientDirected)}
                                    value={true}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Label>
                            <Label className='ml-4'>No
                                <Input
                                    className="ml-2"
                                    type="radio"
                                    name="clientDirected-edit"
                                    checked={!this.props.isFieldNull(this.props.editRequestTicket.clientDirected)}
                                    value={false}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}></Col>
                        <Col className='font-italic'>
                            {this.props.editRequestTicket.clientDirected != null && this.props.editRequestTicket.clientDirected && <Label className='ml-1'>Customer has asked for this functionality</Label>}
                            {this.props.editRequestTicket.clientDirected != null && !this.props.editRequestTicket.clientDirected && <Label className='ml-1'>BO has asked for this to increase productivity and accuracy</Label>}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Notes<br /><span className="pl-2">(specific details of request)</span></Col>
                        <Col>
                            <Input
                                type="textarea"
                                rows={6}
                                name="notes"
                                value={this.props.isFieldNull(this.props.editRequestTicket.notes)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                        </Col>
                    </Row>
                </Col>
                <Col md={6} className="text-right">
                    <Row>
                        <Col md={4}>Status</Col>
                        <Col className='text-left'>
                            {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                type="select"
                                name="statusId"
                                value={this.props.isFieldNull(this.props.editRequestTicket.statusId)}
                                onChange={e => { this.props.onChange(e, 'edit'); this.props.onChange({ persist: function () { }, target: { name: 'statusId', value: '' } }) }} >
                                <option value={0}>SELECT STATUS</option>
                                {this.props.statuses.map(request => (
                                    <option key={request.key} value={this.props.isFieldNull(request.key)}>{request.value}</option>
                                ))}
                            </Input> : this.props.editRequestTicket.statusId != null ? (this.props.statuses.filter(status => parseInt(status.key) === parseInt(this.props.editRequestTicket.statusId))[0].value) : ''}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Assigned To</Col>
                        <Col className='text-left'>
                            {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                type="select"
                                name="assignedEmployeeId"
                                value={this.props.isFieldNull(this.props.editRequestTicket.assignedEmployeeId)}
                                onChange={e => this.props.onChange(e, 'edit')} >
                                <option value={0}>SELECT EMPLOYEE</option>
                                {this.props.employees.map(employee => (
                                    <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.lastName}, {employee.firstName} </option>
                                ))}
                            </Input> : this.props.editRequestTicket.assignedEmployeeId != null ? (this.props.employees.filter(employee => parseInt(employee.employeeId) === parseInt(this.props.editRequestTicket.assignedEmployeeId))[0].lastName + ', ' + this.props.employees.filter(employee => parseInt(employee.employeeId) === parseInt(this.props.editRequestTicket.assignedEmployeeId))[0].firstName) : ""}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Ranking System for Priority</Col>
                        <Col className='text-left'>
                            {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                type="select"
                                name="priorityRankId"
                                value={this.props.isFieldNull(this.props.editRequestTicket.priorityRankId)}
                                onChange={e => this.props.onChange(e, 'edit')} >
                                <option value={0}>SELECT PRIORITY RANK</option>
                                {this.props.priorityRanks.map(priority => (
                                    <option key={priority.key} value={this.props.isFieldNull(priority.key)}>{priority.value}</option>
                                ))}
                            </Input> : this.props.editRequestTicket.priorityRankId != null ? (this.props.priorityRanks.filter(priority => parseInt(priority.key) === parseInt(this.props.editRequestTicket.priorityRankId))[0].value) : ""}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Time Estimate</Col>
                        <Col className='text-left'>
                            {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                type="number"
                                name="timeEstimate"
                                value={this.props.isFieldNull(this.props.editRequestTicket.timeEstimate)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                                : this.props.editRequestTicket.timeEstimate}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Update Notes</Col>
                        <Col className='text-left'>
                            {(this.props.singleEmployee == null || !this.props.singleEmployee) ? <Input
                                type="textarea"
                                rows={6}
                                name="updateNotes"
                                value={this.props.isFieldNull(this.props.editRequestTicket.updateNotes)}
                                onChange={e => this.props.onChange(e, 'edit')} />
                                : this.props.editRequestTicket.updateNotes}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Date Completed</Col>
                        <Col className='text-left'>
                            {(this.props.singleEmployee == null || !this.props.singleEmployee) ?
                                <Input
                                    type="date"
                                    rows={6}
                                    name="completed"
                                    value={String(this.props.isFieldNull(this.props.editRequestTicket.completed)).substring(0, 10)}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                                : this.props.editRequestTicket.completed != null ? this.formatDate(String(this.props.editRequestTicket.completed).substring(0, 10)) : ""}
                        </Col>
                    </Row>
                    <Row className='mt-3'>
                        <Col>
                            <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Request Tickets">
                                <Button
                                    disabled={parseInt(this.props.editRequestTicket.employeeId) === 0 ||
                                        parseInt(this.props.editRequestTicket.teamId) === 0 ||
                                        parseInt(this.props.editRequestTicket.clientId) === 0 ||
                                        parseInt(this.props.editRequestTicket.requestId) === 0
                                    }
                                    color="success"
                                    title="Save Request Ticket"
                                    onClick={this.props.handleEdit}
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </Button>
                            </PermissionWrapper>
                            <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Request Ticket">
                                <ConfirmButton className="mx-1" color="danger" onClick={() => this.props.onDelete(this.props.botRequestTicketId)} title="Delete Request Ticket">
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </ConfirmButton>
                            </PermissionWrapper>
                            <Button
                                color="secondary"
                                title="Cancel"
                                onClick={this.props.handleCancel}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </Button>
                        </Col>
                    </Row>
                </Col>

            </Row>
        </td></tr>
        )
    }

    addRow = () => {
        this.props.info('BOTRequestsForm.js/addRow');
        let clients = this.props.clients;
        if (this.props.singleEmployee && !this.checkPermission('Show All Clients')) {
            const allEmployeeClients = (this.props.userEmployee.primaryCustomers != null ? this.props.userEmployee.primaryCustomers : [])
                .concat(this.props.userEmployee.secondaryCustomers != null ? this.props.userEmployee.secondaryCustomers : [])
                .concat(this.props.userEmployee.teamCustomers != null ? this.props.userEmployee.teamCustomers : [])
                .map(client => client.clientId);
            clients = clients.filter(client => allEmployeeClients.findIndex(employeeClient => employeeClient === client.id) > -1);
        }
        return (<tr><td colSpan={8}>
            <Row className="py-4 text-left align-top ">
                <Col md={6}>
                    {(this.props.singleEmployee == null || !this.props.singleEmployee) && <Row>
                        <Col md={4}>Employee</Col>
                        <Col>
                            <Input
                                type="select"
                                name="employeeId"
                                value={this.props.isFieldNull(this.props.newRequestTicket.employeeId)}
                                onChange={e => this.props.onChange(e)} >
                                <option value={0}>SELECT EMPLOYEE</option>
                                {this.props.employees.map(employee => (
                                    <option key={employee.employeeId} value={this.props.isFieldNull(employee.employeeId)}>{employee.lastName}, {employee.firstName} </option>
                                ))}
                            </Input>
                        </Col>
                    </Row>}
                    {(this.props.singleEmployee == null || !this.props.singleEmployee) && <Row>
                        <Col md={4}>Team</Col>
                        <Col>
                            <Input type="select"
                                name="teamId"
                                onChange={(e) => this.props.onChange(e)}
                                value={this.props.isFieldNull(this.props.newRequestTicket.teamId)}
                            >
                                <option value="0">SELECT TEAM</option>
                                {this.props.teams.map(team => (
                                    <option key={team.id}
                                        value={this.props.isFieldNull(team.id)}>{team.id === -1 ? 'Team Not Set' : team.teamName}</option>
                                ))}
                            </Input>
                        </Col>
                    </Row>}
                    <Row>
                        <Col md={4}>Client</Col>
                        <Col>
                            <Input type="select"
                                name="clientId"
                                onChange={(e) => this.props.onChange(e)}
                                value={this.props.isFieldNull(this.props.newRequestTicket.clientId)}
                            >
                                <option value="0">SELECT CLIENT</option>
                                {clients.map(client => (
                                    <option key={client.id}
                                        value={this.props.isFieldNull(client.id)}>{client.client}</option>
                                ))}
                            </Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Request Category</Col>
                        <Col>
                            <Input
                                type="select"
                                name="requestId"
                                value={this.props.isFieldNull(this.props.newRequestTicket.requestId)}
                                onChange={e => { this.props.onChange(e); this.props.onChange({ persist: function () { }, target: { name: 'requestOther', value: '' } }) }} >
                                <option value={0}>SELECT REQUEST CATEGORY</option>
                                {this.props.requests.map(request => (
                                    <option key={request.key} value={this.props.isFieldNull(request.key)}>{request.value}</option>
                                ))}
                            </Input>
                        </Col>
                    </Row>
                    {parseInt(this.props.newRequestTicket.requestId) === 4 && <Row>
                        <Col md={4}></Col>
                        <Col>
                            <Input
                                placeholder="Enter Custom Category"
                                type="text"
                                name="requestOther"
                                value={this.props.isFieldNull(this.props.newRequestTicket.requestOther)}
                                onChange={e => this.props.onChange(e)} />
                        </Col>
                    </Row>}
                    <Row>
                        <Col md={4}>Connectivity</Col>
                        <Col>
                            <Input
                                placeholder="Connectivity Category"
                                type="text"
                                name="connectivityOther"
                                value={this.props.isFieldNull(this.props.newRequestTicket.connectivityOther)}
                                onChange={e => this.props.onChange(e)} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Requestor Priority</Col>
                        <Col>
                            <Input
                                type="select"
                                name="priorityId"
                                value={this.props.isFieldNull(this.props.newRequestTicket.priorityId)}
                                onChange={e => this.props.onChange(e)} >
                                <option value={0}>SELECT PRIORITY</option>
                                {this.props.priorities.map(priority => (
                                    <option key={priority.key} value={this.props.isFieldNull(priority.key)}>{priority.value}</option>
                                ))}
                            </Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Estimated Time Saved<br /><span className="pl-2">(in hours) for each event</span></Col>
                        <Col>
                            <Input
                                type="number"
                                name="timeSavedEstimate"
                                value={this.props.isFieldNull(this.props.newRequestTicket.timeSavedEstimate)}
                                onChange={e => this.props.onChange(e)} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Client Directed</Col>
                        <Col>
                            <Label className='mr-4'>Yes
                                <Input
                                    className='ml-2'
                                    type="radio"
                                    name="clientDirected"
                                    checked={this.props.isFieldNull(this.props.newRequestTicket.clientDirected)}
                                    value={true}
                                    onChange={e => this.props.onChange(e)} />
                            </Label>
                            <Label className='ml-4'>No
                                <Input
                                    className="ml-2"
                                    type="radio"
                                    name="clientDirected"
                                    checked={!this.props.isFieldNull(this.props.newRequestTicket.clientDirected)}
                                    value={false}
                                    onChange={e => this.props.onChange(e)} />
                            </Label>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}></Col>
                        <Col className='font-italic'>
                            {this.props.newRequestTicket.clientDirected != null && this.props.newRequestTicket.clientDirected && <Label className='ml-1'>Customer has asked for this functionality</Label>}
                            {this.props.newRequestTicket.clientDirected != null && !this.props.newRequestTicket.clientDirected && <Label className='ml-1'>BO has asked for this to increase productivity and accuracy</Label>}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>Notes<br /><span className="pl-2">(specific details of request)</span></Col>
                        <Col>
                            <Input
                                type="textarea"
                                rows={6}
                                name="notes"
                                value={this.props.isFieldNull(this.props.newRequestTicket.notes)}
                                onChange={e => this.props.onChange(e)} />
                        </Col>
                    </Row>
                </Col>
                <Col md={4} className="text-right">
                    <Button
                        disabled={parseInt(this.props.newRequestTicket.employeeId) === 0 ||
                            parseInt(this.props.newRequestTicket.teamId) === 0 ||
                            parseInt(this.props.newRequestTicket.clientId) === 0 ||
                            parseInt(this.props.newRequestTicket.requestId) === 0
                        }
                        color="primary"
                        onClick={this.props.handleAdd}
                    >Add Request Ticket</Button>
                </Col>
            </Row >
        </td></tr>
        )
    }

    render() {
        this.props.info('BOTRequestsForm.js/render');
        const assigned = [...this.props.botRequestTickets].filter(bot => parseInt(bot.projectType) !== 1 && parseInt(bot.projectType) !== 2 && parseInt(bot.statusId) >= 2 && parseInt(bot.statusId) <= 4 && parseInt(bot.technologyStatus) !== 2);
        const unassigned = [...this.props.botRequestTickets].filter(bot => parseInt(bot.projectType) !== 1 && parseInt(bot.projectType) !== 2 && parseInt(bot.statusId) < 2 && parseInt(bot.technologyStatus) !== 2);
        return (
            <>
                <Table className={"adminContainer" + (this.props.singleEmployee ? " wraptable" : "")}>
                    <thead>
                        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Request Tickets">
                            {this.addRow()}
                        </PermissionWrapper>
                    </thead>
                </Table>
                {assigned.length > 0 && <CollapseCard title={`Assigned (${assigned.length})`} open={false}>
                    <Table className={"adminContainer" + (this.props.singleEmployee ? " wraptable" : "")}>
                        {/* <thead>
                            <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Request Tickets">
                                {this.addRow()}
                            </PermissionWrapper>
                        </thead> */}
                        {assigned.length > 0 && <thead>
                            <tr className="adminRow font-weight-bold widgetRow text-left">
                                {this.props.columns
                                    .filter(col => (this.props.singleEmployee == null || !this.props.singleEmployee) || (this.props.singleEmployee && (!col.singleEmployeeHide || col.singleEmployeeHide == null)))
                                    .map((col, colIndex) => (
                                        <th key={col.name} onClick={() => this.props.handleSort(colIndex)} className={col.sort !== false && ((this.props.singleEmployee == null || !this.props.singleEmployee)) ? 'pointer' : ''}>
                                            {col.name}
                                            {(this.props.singleEmployee == null || !this.props.singleEmployee) && <span className={"chevron mr-2 " + (colIndex === this.props.selectedSortColumnIndex ? "text-info" : "text-white")}><FontAwesomeIcon icon={this.props.selectedSortAscending ? faChevronUp : faChevronDown} /></span>}
                                        </th>
                                    ))}
                            </tr>
                        </thead>}
                        <tbody>
                            {assigned.map(botRequestTicket => (
                                <Fragment key={botRequestTicket.id}>{this.props.botRequestTicketId === botRequestTicket.id ? this.editRow(botRequestTicket) : this.standardRow(botRequestTicket)}</Fragment>
                            ))}
                        </tbody>
                    </Table>
                </CollapseCard>}
                {unassigned.length > 0 && <CollapseCard title={`Unassigned (${unassigned.length})`} open={false}>
                    <Table className={"adminContainer" + (this.props.singleEmployee ? " wraptable" : "")}>
                        {/* <thead>
                            <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Request Tickets">
                                {this.addRow()}
                            </PermissionWrapper>
                        </thead> */}
                        {unassigned.length > 0 && <thead>
                            <tr className="adminRow font-weight-bold widgetRow text-left">
                                {this.props.columns
                                    .filter(col => (this.props.singleEmployee == null || !this.props.singleEmployee) || (this.props.singleEmployee && (!col.singleEmployeeHide || col.singleEmployeeHide == null)))
                                    .map((col, colIndex) => (
                                        <th key={col.name} onClick={() => this.props.handleSort(colIndex)} className={col.sort !== false && ((this.props.singleEmployee == null || !this.props.singleEmployee)) ? 'pointer' : ''}>
                                            {col.name}
                                            {(this.props.singleEmployee == null || !this.props.singleEmployee) && <span className={"chevron mr-2 " + (colIndex === this.props.selectedSortColumnIndex ? "text-info" : "text-white")}><FontAwesomeIcon icon={this.props.selectedSortAscending ? faChevronUp : faChevronDown} /></span>}
                                        </th>
                                    ))}
                            </tr>
                        </thead>}
                        <tbody>
                            {unassigned.map(botRequestTicket => (
                                <Fragment key={botRequestTicket.id}>{this.props.botRequestTicketId === botRequestTicket.id ? this.editRow(botRequestTicket) : this.standardRow(botRequestTicket)}</Fragment>
                            ))}
                        </tbody>
                    </Table>
                </CollapseCard>}
                
            </>
        );

    }
}

export default BOTRequestsForm;
